import React from 'react';
import { motion } from 'framer-motion';
export function QuoteBand() {
  return <section className="relative h-[60vh] md:h-[70vh] overflow-hidden" data-id="element-97">
      <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1600&q=80&auto=format&fit=crop" alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-98" />
      <div className="absolute inset-0 bg-ink/40" data-id="element-99" />
      <div className="relative h-full flex items-center justify-center px-6 md:px-10" data-id="element-100">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2
      }} className="font-serif-display italic text-bone text-center text-3xl md:text-6xl leading-[1.15] max-w-3xl" data-id="element-101">
          "It's not just a trip. <br data-id="element-102" />
          It's a shift."
        </motion.p>
      </div>
    </section>;
}